
import {gql} from "apollo-angular";


const GET_LAST_ANNOUNCEMENT = gql`
query announce($isDeleted: Boolean = false, $isActive: Boolean = true, $first: Int = 1, $orderBy: String = "-created_date") {
  announce(
    first: $first
    isDeleted: $isDeleted
    isActive: $isActive
    orderBy: $orderBy
  ) {
    edges {
      node {
        id
        name
        imageUrl
        texte
        createdDate
        publishedAnnounces {
          edges {
            node {
              published
              useDevice
              comment
              createdDate
              spaceAnnounce {
                edges {
                  node {
                    id
                    spaces {
                      id
                      name
                    }
                  }
                }
              }
              announce {
                id
                name
                texte
                isActive
                imageUrl
                createdDate
              }
            }
          }
        }
      }
    }
  }
}
`


const GET_ANNOUNCEMENTS = gql`
query getAllAnnounces($isDeleted: Boolean = false, $isActive: Boolean = true) {
  announce(isDeleted: $isDeleted, isActive: $isActive) {
    edges {
      node {
        id
        name
        imageUrl
        texte
        createdDate
        publishedAnnounces {
          edges {
            node {
              published
              useDevice
              comment
              createdDate
              spaceAnnounce {
                edges {
                  node {
                    id
                    spaces {
                      id
                      name
                    }
                  }
                }
              }
              announce {
                id
                name
                texte
                isActive
                imageUrl
                createdDate
              }
            }
          }
        }
      }
    }
  }
}
`



const GET_SPACE_ANNOUNCEMENT_BY_ID = gql`
query spaceAnnounceById($id: ID!, $isDeleted: Boolean = false) {
  spaceAnnounce(id: $id, isDeleted: $isDeleted) {
    edges {
      node {
        id
        publishedAnnounce {
          published
          useDevice
          comment
          createdDate
          announce {
            id
            name
            texte
            isActive
            imageUrl
            createdDate
          }
        }
      }
    }
  }
}
`









export {GET_LAST_ANNOUNCEMENT, GET_ANNOUNCEMENTS, GET_SPACE_ANNOUNCEMENT_BY_ID}
